import React, { useRef } from "react";
import Popover from "../../../../popover/popover/Popover";
import CustomLink from "../link/CustomLink";
import NavImage from "../navImage/NavImage";
import { BrandContainer } from "./BrandStyles";
const Brand = ({ logo, text, link, contentHeight, builds, customLinkComponent, isVertical }) => {
    const buildRef = useRef(null);
    const Content = () => (React.createElement(React.Fragment, null,
        !!logo && React.createElement(NavImage, { src: logo, height: contentHeight }),
        !!text && React.createElement(React.Fragment, null, text)));
    const hasBuilds = !!builds?.length;
    let brandHeight;
    if (typeof contentHeight === "string") {
        brandHeight = parseInt(contentHeight.replace(/[^0-9]/g, ""));
    }
    else {
        brandHeight = contentHeight;
    }
    return (React.createElement(React.Fragment, null,
        hasBuilds && (React.createElement(Popover, { ref: buildRef, trigger: "hover", delay: 2000, location: "right" },
            React.createElement(Popover.Header, null, "Build Version"),
            React.createElement(Popover.Body, null, builds?.map((build) => (React.createElement("div", { key: build.build },
                build.build,
                " ",
                build.name)))))),
        React.createElement(BrandContainer, { height: brandHeight, ref: hasBuilds ? buildRef : undefined, isVertical: isVertical }, !!link?.length ? (React.createElement(CustomLink, { to: link, customLinkComponent: customLinkComponent, isVertical: isVertical },
            React.createElement(Content, null))) : (React.createElement(Content, null)))));
};
export default Brand;
//# sourceMappingURL=Brand.js.map